import { cva } from '@/styled-system/css';

export const upsellBodyRecipe = cva({
  base: {
    'marginBlockStart': 'Upsell.Body.margin.heading-toMessage',

    '& > [data-c11n-component="Text"]': {
      color: 'inherit',
      textStyle: 'body',
    },
    '& > [data-c11n-component="Paragraph"]': {
      color: 'inherit',
      textStyle: 'body',
    },
  },
  variants: {
    tone: {
      neutral: {
        color: 'Upsell.Body.neutral.text',
      },
      soft: {
        color: 'Upsell.Body.soft.text',
      },
      hero: {
        color: 'Upsell.Body.hero.text',
      },
      impact: {
        color: 'Upsell.Body.impact.text',
      },
    },
  },
});
